<template>
    <div>
    <Drawer :mask-closable="true" @on-close="onCloseManageDrawer()" class="demo-drawer-prime"
            title="Manage Order" v-model="$parent.manageOrderDrawer" :width="responsive?'100vw':'1150 '">
        <div slot="header">
     <!--       <Col span="20"><h3>Manage Order</h3></Col>
                <Col span="4"><Button @click="splitOrderDrawer = true">Split Order</Button></Col>  -->
            <MOHeader ref="manage-order-header" @openSplitDrawer="splitOrderDrawer = true"></MOHeader>
        </div>
      <div >
        <external-status-bar></external-status-bar>
      </div>

        <Split v-model="splitPane" max="450px" min="350px">
            <div slot="left" class="left-split-pane">
       <!--   <order-detail :orderId="orderId" @orderData="onReceiveOrderData($event)" ref="order-detail-page">
              </order-detail>           -->
                <component v-bind:is="viewPath" :orderId="orderId" :order="orderData"></component>

                <template v-for="(key, index) in Object.keys(constant.internalStatus)" v-if="generateNextStatusButton">
                  <Button style="margin-top: 15px" @click="updateOrder(constant.internalStatus[Object.keys(constant.internalStatus)[index+1]])"
                        v-if="$parent.currentOrderStatus == constant.internalStatus[key] && !$parent.viewPath">
                            {{sentenceCase(Object.keys(constant.internalStatus)[index+1])}}
                  </Button>
                </template>
              <template v-if="errMessages.length">
                <p style="margin:5px 0px">The Following Orders are still not in
                  <i v-if="$parent.currentOrderStatus === Constants.internalStatus.waitingForDeparture">'Waiting For Departure'</i>
                  <i v-else-if="$parent.currentOrderStatus === Constants.internalStatus.onTheWayToDropCityWarehouse">'On The Way To Drop City Warehouse'</i>
                  stage</p>
                <ul style="color: red; margin: 10px">
                  <li v-for="(err, index) in errMessages" :key="index">{{err}}</li>
                </ul>
              </template>
     <!-- ---------------------------- Order's Extra Details (Note History) --------------------------------------------- -->
                <div style="font-size: 15px;margin: 25px 0px 15px 0;"><strong>Note History</strong>
                <Select v-model="noteType" style="width: 100px;margin: 0 0 0 100px" clearable>
                  <Option value="NORMAL">Normal</Option>
                  <Option value="CANCEL">Cancel</Option>
                </Select>
                </div>
                <div style="max-height: 250px;overflow-y: scroll;">
                    <Timeline>
                        <TimelineItem v-for="(note, index) in notes.filter(n => noteType?n.type===noteType:true)" :key="index">
                            <p class="time"><p style="margin-top: -2px;font-size: 12px;margin-bottom: 6px;margin-left: 5px;color: gray;">{{moment(note.createdOn).format('DD/MM/YY hh:mm:ss A')}}</p></p>
                            <p class="content">
                              <template v-if="note.type==='CANCEL'">
                                <span class="note-list-label">Type:</span> <Tag color="error" style="margin:0 0 0 10px">Cancel Note</Tag><br>
                                <span class="note-list-label">Cancel Reason:</span> {{orderData.orderDetails.cancellationReason}}<br>
                              </template>
                                <span class="note-list-label">Created By:</span> {{note.CreatedBy.name}}<br>
                                <span class="note-list-label">Note:</span> {{note.note}}<br>
                            </p>
                        </TimelineItem>
                    </Timeline>
                    <template v-if="!notes.length">No History Available.</template>
                </div>
     <!-- -----------------------------x----------------x---------------x----------------x----------------- -->
            </div>

            <div slot="right" class="right-split-pane">
        <!--   <add-order-other-detail :orderId="orderId" :orderData="orderData" ref="other-detail-form"
                      v-if="$parent.currentOrderStatus===constant.internalStatus.pendingForApproval">
              </add-order-other-detail>                             -->
         <!--     <vehicle-assignment :orderId="orderId" ref="vehicle-assignment-component"
                      v-if="$parent.currentOrderStatus===constant.internalStatus.approval">
              </vehicle-assignment>                                                             -->
             <time-history ref="time-history" :orderId="orderId"></time-history>
            </div>
        </Split>


    </Drawer>

   <Drawer :mask-closable="false" @on-close="onCloseSplitDrawer" class="demo-drawer-prime"
           title="Split Order" v-model="splitOrderDrawer" width="1000">
       <div slot="header">
           <Row>
               <Col span="20"><h3>Split Order</h3></Col>
               <Col span="4"><Button type="success" style="font-weight: bolder;letter-spacing: 2px" @click="validateChildForms">SPLIT</Button></Col>
           </Row>
       </div>
       <div :style="'width:'+ ((442*numOfForms)+58) + 'px'">
           <template v-for="(i, index) in numOfForms">
             <div :style="'width:400px;float: left'">
                 <split-order :formIndex="index" :resetListener="resetBus" :submitListener="submitBus" :ref="'split-form'+index"></split-order>
             </div>
             <div style="width: 10px;float: left;margin: 0 16px">
               <Divider style="height: 85vh" type="vertical"></Divider></div>
           </template>
       <div style="width: 48px;float: left;margin-right: 10px">
           <Card style="background-color: #f3f3f3" class="add-btn-card">
               <div @click="incrementSplitForm()" style="height: 85vh"><Icon type="md-add" style="margin: 42vh 0px 0px 12px;font-size: 21px;"/></div>
           </Card>
       </div>
       </div>
   </Drawer>
 </div>
</template>

<script>
import OrderDetail from "../OrderDetail"
import AddOrderOtherDetail from "./AddOrderOtherDetail"
import VehicleAssignment from "./VehicleAssignment.vue"
import SplitOrder from './SplitOrder'
import MOHeader from './MOHeader'
import ExternalStatusBar from './ExternalStatusBar'
import TimeHistory from './TimeHistory'
import PendingForm from './PendingForm'
import ApprovalForm from './ApprovalForm'
import { GET_SINGLE_ORDER } from '../../graphql/queries/Orders'
import {SUBSCRIBE_SINGLE_ORDER} from '../../graphql/subscription/Orders'
import {UPDATE_ORDER_BY_STATUS} from '../../graphql/mutations/orders'
import {Constants} from '../../Constants/Constant'
import {SUBSCRIBE_ORDER_NOTE_HISTORY} from '../../graphql/subscription/Orders'
import Vue from 'vue'
import moment from 'moment'
import {
  UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID,
  VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID
} from "../../graphql/queries/truckOrders";
    export default {
        apollo: {
            orders: {
                query: GET_SINGLE_ORDER,
                variables() {
                    return {
                        orderId: this.orderId
                    }
                },
                skip: false,
                subscribeToMore: {
                    document: SUBSCRIBE_SINGLE_ORDER,
                    variables() {
                        return {
                            orderId: this.orderId
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        if(subscriptionData.data.orders.length){
                            this.onReceiveOrderData(subscriptionData.data.orders[0]);
                        }
                    },
                },
                result ({ data, loading }) {
                    if (!loading && data.orders.length) {
                        this.onReceiveOrderData(data.orders[0]);
                    }
                }
            },
            $subscribe: {
              notes: {
                query: SUBSCRIBE_ORDER_NOTE_HISTORY,
                skip() {
                  return !this.orderData
                },
                variables() {
                  return {orderId: this.orderId}
                },
                result({data}) {
                  this.notes = data.notes
                }
              },
            }
        },
        name: "ManageOrder",
        props: ['orderId','viewPath'],
        components: {OrderDetail, AddOrderOtherDetail, VehicleAssignment ,SplitOrder,
            TimeHistory, MOHeader, ExternalStatusBar, PendingForm, ApprovalForm},
        data(){
            return{
                moment: moment,
                constant: Constants,
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                mutation_UPDATE_ORDER_BY_STATUS: UPDATE_ORDER_BY_STATUS,
                resetBus: new Vue(),
                submitBus: new Vue(),
                splitOrderDrawer: false,
                numOfForms: 2,
                orderData: '',
                splitPane: 0.5,
                notes: [],
                noteType: '',
                noteTypeOptions: ['NORMAL', 'CANCEL'],
                responsive:false,
                loader1: false,
                errMessages: [],
            }
        },
        computed: {
          generateNextStatusButton(){
            return  ![Constants.internalStatus.cancel].includes(this.orderData?.internalStatus?.id)
          }
        },
        methods: {
          onResponsiveInverted() {
            if (window.innerWidth < 991) {
              this.responsive = true
            } else {
              this.responsive = false
            }
          },
          sentenceCase(str){
            if(str){
                let result = str.replace( /([A-Z])/g, " $1" );
                return result.charAt(0).toUpperCase() + result.slice(1);
              }
          },
            onCloseManageDrawer(){
              // if(this.$parent.currentOrderStatus===this.constant.internalStatus.pendingForApproval){
              //    this.$refs['other-detail-form'].reset();
              //  }
               // if(this.$parent.currentOrderStatus===this.constant.internalStatus.approval){
               //   this.$refs['vehicle-assignment-component'].reset();
               // }
            },
            onCloseSplitDrawer(){
                this.numOfForms = 2;
                this.resetBus.$emit('reset')
            },
            incrementSplitForm(){
                this.numOfForms++
            },
            validateChildForms(){
                let count = 0;
                for(var i=0; i<this.numOfForms; i++){
                    let formName = 'split-form' + i
                    if(this.$refs[formName][0].validateForm()){
                        count++
                    }
                }
                if(count == this.numOfForms){
                    console.log('form all true');
                    this.submitBus.$emit('splitOrder')
                }else{
                    this.$Message.error('Please fill all required fields of each Form!');
                }
            },
            onReceiveOrderData(orderData){
                this.orderData = orderData;
                this.$refs['manage-order-header'].orderData = orderData;
                this.$refs['time-history'].orderData = orderData;
                this.$refs['time-history'].getContacts(orderData);
            },
            async updateOrder(internalStatusId){
                let truckOrderId = this.orderData.orderDetails.transportVehicleAssignId;
                if(internalStatusId === Constants.internalStatus.onTheWayToDropCityWarehouse) this.onWayToDropCityWarehouse(truckOrderId);
                else if(internalStatusId === Constants.internalStatus.atDestinationCityWarehouse) this.onAtDestinationCityWarehouse(truckOrderId);
                else{
                  let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_ORDER_BY_STATUS,
                    variables: {
                        orderId: this.$parent.orderId,
                        internalstatus: internalStatusId,  //Change internalStatusId
                    }
                  });
                  if(response.data){
                      this.$Message.success('Order updated successfully!');
                      this.$parent.manageOrderDrawer = false
                  }
                }
            },
          onWayToDropCityWarehouse(truckOrderId){
            let stageId = Constants.internalStatus.waitingForDeparture
            let updateBy_stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
            this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
          },
          onAtDestinationCityWarehouse(truckOrderId){
            let stageId = Constants.internalStatus.onTheWayToDropCityWarehouse
            let updateBy_stageId = Constants.internalStatus.atDestinationCityWarehouse
            this.verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, this.updateOrdersStatusUsingTruckOrderId, updateBy_stageId)
          },
          async verifyOrdersByTruckOrderIdAndStageId(truckOrderId, stageId, callback, updateBy_stageId){
            this.loader1 = true
            let response = await this.$apollo.query({
              query: VERIFY_ORDERS_BY_TRUCK_ORDER_ID_AND_STAGE_ID,
              fetchPolicy: 'network-only',
              variables: {
                truckOrderId: truckOrderId,
                stageId: stageId
              }
            })
            if(response.data.orders.length){
              this.errMessages = response.data.orders.map((obj) => obj.orderNumber)
              this.loader1 = false
            }else{
              callback(truckOrderId, updateBy_stageId)
            }
          },
          async updateOrdersStatusUsingTruckOrderId(truckOrderId, updateBy_stageId){
            let response = await this.$apollo.mutate({
              mutation: UPDATE_ORDERS_AND_TRUCKORDER_STATUS_USING_TRUCK_ORDER_ID,
              variables: {
                truckOrderId: truckOrderId,
                stageId: updateBy_stageId,
                lastStageUpdatedOn : moment().format(),
                lastStageUpdatedBy : this.userObj.user.id
              }
            })
            if(response.data){
              this.loader1 = false
              this.$Message.success('Multiple Orders updated successfully!')
            }
          }
        },
      mounted() {
        this.onResponsiveInverted()
        window.addEventListener('resize', this.onResponsiveInverted)
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.onResponsiveInverted)
      },

    }
</script>

<style scoped>
    /deep/ .add-btn-card > .ivu-card-body{
        padding: 0px;
    }
    /deep/ .ivu-drawer-body{
        height: calc(100% - 60px);
    }
    .left-split-pane{
        padding: 0 5px 0 0;
    }
    .right-split-pane{
        padding: 0 0 0 12px;
    }

    /deep/ .right-split-pane{
      padding: 10px 0px 0px 12px !important;
      overflow-y: auto;
      max-height: 70%;
    }
  /deep/ .ivu-drawer-body{
    /*overflow: hidden;*/
  }
  .note-list-label{
    color: #808080;
    font-size: 14px;
    margin-right: 4px;
  }



</style>
